export const withActions = (onAction: any, select: any) => (column: any) => {
  if (!column.render) return column

  return {
    ...column,
    render: (text: any, render: any) => column.render(text, render, onAction, select),
  }
}
